module.exports = __webpack_public_path__ + "media/packs/landing_page/images/fitpass-logo-white-25ff6639d74d237910916478bbc4c3e7.png";